import type { HeroData } from '@/content/types';

export default function Hero(props: HeroData) {
  return (
    <section
      className="section-padding"
      style={{ textAlign: 'center', maxWidth: 'var(--container-max)', margin: '0 auto' }}
    >
      {props.pill && (
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          background: 'transparent', color: 'var(--color-ink)',
          border: '1px solid #fff',
          padding: '6px 14px', borderRadius: 'var(--radius-pill)',
          fontSize: 13, fontWeight: 500,
        }}>
          {props.pill.dot && (
            <span style={{
              width: 7, height: 7, background: 'var(--color-success)',
              borderRadius: '50%', boxShadow: '0 0 0 3px rgba(34,197,94,0.15)',
            }} />
          )}
          {props.pill.label}
        </span>
      )}
      <h1
        className="h-display"
        style={{ margin: '20px auto 16px', whiteSpace: 'pre-line' }}
      >
        {props.headline}
      </h1>
      {props.subheadline && (
        <p style={{
          fontSize: 16, color: 'var(--color-muted)',
          maxWidth: 720, margin: '0 auto 24px', lineHeight: 1.5,
        }}>
          {props.subheadline}
        </p>
      )}
      <a href={props.cta.href} className="btn-primary">
        {props.cta.label}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
          <path d="M3 8h10M9 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
      {props.screenshot && (
        <div style={{ marginTop: 40 }}>
          <div style={{
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            background: '#0a0a0a',
            padding: 8,
            boxShadow: '0 30px 80px rgba(15, 23, 42, 0.18)',
          }}>
            <img
              src={props.screenshot.src}
              alt={props.screenshot.alt}
              width={props.screenshot.width}
              height={props.screenshot.height}
              fetchPriority="high"
              decoding="async"
              style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 'var(--radius-md)' }}
            />
          </div>
        </div>
      )}
    </section>
  );
}
